<template>
  <Container v-if="showSection">
    <SectionHeader
      title="E-books"
      description="I am excited to share my curated collection of e-books on health, happiness, and wellness with you! These books are full of insightful tips and practical advice that you can use to make positive changes in your life"
    />
    <InfiniteScroll :once="true" @isvisible="loadData" v-if="loading">
      <div class="list">
        <div class="item" v-for="i in 6" :key="i">
          <div class="thumbnail preLoaderPlaceholder"></div>
          <div class="title preLoaderPlaceholder"></div>
          <div class="author preLoaderPlaceholder"></div>
        </div>
      </div>
    </InfiniteScroll>
    <div class="list" v-else>
      <Item v-for="item in data" :key="item.id" :data="item" />
    </div>
  </Container>
</template>
<script>
import Item from "./item.vue";
export default {
  components: {
    Item,
  },
  data() {
    return {
      data: [],
      loading: true,
      showSection: true,
    };
  },
  methods: {
    loadData() {
      axios.get(this.$route("home.ebooks.api")).then(({ data }) => {
        this.data = data.data || [];
        setTimeout(() => {
          this.loading = false;
          this.showSection = this.data.length > 0;
        }, 100);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  grid-gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 1rem;
  }

  @media (max-width: 576px) {
    gap: 0.5rem;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }

  .item {
    .thumbnail.preLoaderPlaceholder {
      height: 380px;
      margin: 0;
      border-radius: 5px;
      @media (max-width: 768px) {
        height: 300px;
      }
    }
    .title.preLoaderPlaceholder {
      margin: 0.6rem;
    }
    .author.preLoaderPlaceholder {
      margin: 0.6rem;
      margin-bottom: 1.2rem;
      padding: 10px;
      width: 60%;
    }
  }
}
</style>